
























































import Vue from 'vue';
import Component from 'vue-class-component';
import TicketLabel from './TicketLabel.vue';
import TicketStatus from './TicketStatus.vue';
import dateFormat from '../helpers/dateFormat';
import extractUserFromTicket from '../helpers/extractUserFromTicket';
import { TicketStatus as TicketStatusType } from '../store/ticketsStore.d';
import config from '../config';

const TicketRowProps = Vue.extend({
  props: {
    ticket: Object,
  },

  data() {
    return {
      avatarUrl: config.avatarUrl,
    };
  },
});

@Component({
  name: 'TicketRow',

  components: {
    TicketLabel,
    TicketStatus,
  },
})

export default class TicketRow extends TicketRowProps {
  get createdAtDate() {
    return dateFormat(new Date(this.ticket.created_at));
  }

  get statusIdentifier() {
    const { status }: { status: TicketStatusType | null } = this.ticket;
    return status ? status.identifier : 'unknown';
  }

  get statusTitle() {
    const { status }: { status: TicketStatusType | null } = this.ticket;
    return status ? status.title : 'unknown';
  }

  get userInfo() {
    return extractUserFromTicket(this.ticket);
  }
}
